import content from "app-content";

const getPartnerFulfilsFulfilmentStrings = ({
  seller: { description: sellerDescription }
}) => {
  const { dtc_seller_info_label } = content;

  return { dtc_seller_info_label, sellerDescription };
};

export default getPartnerFulfilsFulfilmentStrings;
